import React from 'react';
import { Grid, Card, CardContent, Typography, Skeleton } from '@mui/material';

const fmt = {
  calls:   n => Number(n).toLocaleString(),
  tokens:  n => n >= 1e6 ? `${(n/1e6).toFixed(1)}M` : Number(n).toLocaleString(),
  cost:    n => `$${Number(n).toFixed(2)}`,
  ms:      n => `${Math.round(Number(n)).toLocaleString()} ms`,
  pct:     n => n == null ? '—' : `${Number(n).toFixed(2)}%`,
};

export default function AiUsageMetricCards({ summary, loading }) {
  const cards = [
    { label: 'Calls',        value: fmt.calls(summary?.total_calls ?? 0) },
    { label: 'Tokens In',    value: fmt.tokens(summary?.total_tokens_in ?? 0) },
    { label: 'Tokens Out',   value: fmt.tokens(summary?.total_tokens_out ?? 0) },
    { label: 'Est. Cost',    value: fmt.cost(summary?.total_cost_usd ?? 0) },
    { label: 'Avg Latency',  value: fmt.ms(summary?.avg_latency_ms ?? 0) },
    { label: 'Error Rate',   value: fmt.pct(summary?.error_rate_pct ?? 0) },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map(({ label, value }) => (
        <Grid item xs={6} md={2} key={label}>
          <Card variant="outlined">
            <CardContent sx={{ pb: '12px !important' }}>
              {loading
                ? <Skeleton width="60%" height={36} />
                : <Typography variant="h5" fontWeight={700}>{value}</Typography>
              }
              <Typography variant="caption" color="text.secondary" textTransform="uppercase">
                {label}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
